function keyupDelay(callback, ms) {
    var timer = 0;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}
var $consultantNameField = $('input[name=PA1]');
$consultantNameField.on('keyup', function () {
    console.log('hiding');
    $consultantNameField.next('.autosave-result').hide();
});
$consultantNameField.on('keyup paste change', keyupDelay(function() {
    var field = $(this);
    var statusEl = field.next('.autosave-result');
    statusEl.show().removeClass('text-success text-danger');
    statusEl.text('...');

    var value = field.val();
    var url = field.data('save-endpoint');
    var token = $('meta[name="csrf-token"]').attr('content');
    var data = {
        PA1: value,
        _token: token
    };
    $.post(url, data, function(response) {
        statusEl.show();
        statusEl.text(response.message);
        if(response.success) {
            statusEl
                .removeClass('text-danger')
                .addClass('text-success')
            ;
        } else {
            statusEl
                .removeClass('text-success')
                .addClass('text-danger')
            ;
        }
        window.setTimeout(function() {
            statusEl.fadeOut();
        }, 3000);
    });
}, 1000));
